import React from "react";
import L1c1 from "../L1C1/L1C1";

const lesson1 = {
  info: {
    name: "宠物狗",
    subname: [
      "PREDA:用于定义在具有中继执行的并行多链体系结构上执行的状态和交易逻辑",
    ],
    intro:
      "在现有的区块链系统中，比特币对“货币”进行编程，以太坊对“应用”进行编程，与之相比，Libra对“资产”进行编程。\n\n在Libra 中我们可以定义一些比货币更复杂的资产类型，这种资产被称为 “资源”。Libra利用Move语言限制对资源的操作来防止不恰当的修改，从而提高资产的安全性。\n\nMove为 Libra 区块链提供安全、可编程的基础，该语言针对“资产”进行编程的方式，和对安全性的严格限制，使其十分适合用于发行数字货币、处理区块链交易以及验证器管理。\n\n在本课程中，我们使用Move语言来搭建一个城堡并实现城堡扩张和对战等功能，以帮助初学者更快速地学习这门语言。",
    goback: "←目录",
    editor: "编辑器",
    lesson: "教程",
    copyAnswer: "复制答案",
    learnmore: "了解更多",
    start: "开始学习",
    indexpage: "https://docs.dioxide.network/puppy",
    learninide: ["本课程代码能够在PREDA环境中编译通过", "前往编译环境"],
    practice: "现在开始",
  },
  local: {
    hint: "提示",
    previous: "上一章",
    next: "下一章",
    catalog: "目录",
    checkcode: "检查代码",
    showAnswer: "显示答案",
    hideAnswer: "隐藏答案",
    contitle: ["恭喜完成本章~", "恭喜完成本课~", "精彩还在继续"],
    concontent: [
      "点击“继续前进”，迎接新的挑战吧！",
      "本课到此结束，点击“返回”回到目录页！点击“下一课”继续学习关于PREDA的新知识！",
      "Hi~恭喜你已经完成目前课程的所有内容了~更多课程将不久之后为大家呈现。现在，让我们前往PREDA IDE编写自己的CryptoPuppy合约吧！",
    ],
    concontinue: ["继续前进", "返回", "前往PREDA IDE", "下一课"],
    shut: "关闭窗口",
    target: "课程简介",
    keypoint: "知识点",
    detail: "查看详情",
  },
  lessonserial: "第1课",
  title: "",
  intro: [
    "在课程1中，我们将引导你建立自己的宠物狗，你的宠物狗具有专属的独一无二的属性，比如颜色，性别，品种等。",
    "定义合约;布尔值和整数类型;合约中的状态变量;字符串类型;结构体;数组",
  ],
  key: 1,
  total: 7,
  chapters: [
    {
      title: "第一章 概述",
      instruction: `## 第一章 概述\n\n在第一课中我们将学习如何定义一个Puppy。\n\n- 我们将通过合约来建立新的Puppy\n- 我们的Puppy会被保存在数据库（区块链）中\n\n在之后的章节中，我们Puppy的功能会逐渐增加，比如Puppy繁殖、Puppy买卖等。 \n\n### Puppy有哪些属性？\n\n每个Puppy具有名字、年龄、DNA。其中，DNA决定Puppy的颜色，种类，体型大小等。\n\n### DNA如何影响Puppy？\n\nPuppy的颜色，种类，体型大小由DNA决定，DNA是一个8位整数，比如：83451029。\n\nDNA的每一位对应着Puppy的一个属性，具体如下：\n\n|  1   |  2   |  3   |    4     |    5     |    6     |  7   |    8     |\n| :--: | :--: | :--: | :------: | :------: | :------: | :--: | :------: |\n| 大小 | 样式 | 颜色 | 徽标样式 | 徽标颜色 | 徽标位置 | 种族 | 特殊标识 |\n\n出于游戏趣味性的考虑，我们将DNA设定为根据建立Puppy时的区块深度随机产生，而不是由用户自主决定，当然这并不意味着Puppy的样子是不确定的，因为在建立Puppy的同时DNA就是一个固定值了。每个新建立的Puppy的名字由用户输入，等级年龄为值为0。\n\n### 实战演习\n\n1. 请拖动页面右侧的滑块，探索不同DNA对应的Puppy外观。\n\n\n **了解了这些基础内容后，点击下一章，继续学习PREDA语言**。\n\n`,
      type: 1,
      show() {
        return <L1c1 lang="0" />;
      },
    },
    {
      title: "第二章 定义合约",
      instruction: `## 第二章 定义合约\n\n合约是在区块链上运行的计算机程序，我们通过运行合约从而在区块链上完成一系列操作，比如转账、购买商品等。\n\n在PREDA中使用\`contract\`关键字定义合约：\n\n    contract MyContract { \n    // 合约名称是 "MyContract" \n    // 合约代码: \n    // 用户定义的枚举类型 \n    // 用户定义的结构体类型 \n    // 状态变量定义 \n    // 合约函数定义 \n    }\n\n### 实战演习\n\n为了建立我们的Puppy，我们要先建立一个名为\`CryptoPuppy\`的合约，我们将在该合约中逐渐实现建立Puppy的一系列功能。\n\n 1. 建立一个空合约\`CryptoPuppy\`；\n\n`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: "//在这里输入代码",
          answer: "contract CryptoPuppy {\n\n}",
        },
      ],
    },
    {
      title: "第三章 布尔值和整数类型",
      instruction: `## 第三章 布尔值和整数类型\n\nPREDA具有以下内置的布尔和整数类型：\n\n |  类型   |  字节数   |  取值范围   |\n| :--: | :--: | :--: |\n| bool | 1 | true / false |\n| int8 | 1 | \\[-2^7, 2^7-1\\] |\n| int16 | 2 | \\[-2^15, 2^15-1\\] |\n| int32 | 4 | \\[-2^31, 2^31-1]\\] |\n| int64 | 8 | \\[-2^63, 2^63-1]\\] |\n| int128 | 16 | \\[-2^127, 2^127-1]\\] |\n| int256 | 32 | \\[-2^255, 2^255-1]\\] |\n| int512 | 64 | \\[-2^511, 2^511-1]\\] |\n| uint8 | 1 | \\[0, 2^8-1\\] |\n| uint16 | 2 | \\[0, 2^16-1\\] |\n| uint32 | 4 | \\[0, 2^32-1]\\] |\n| uint64 | 8 | \\[0, 2^64-1]\\] |\n| uint128 | 16 | \\[0, 2^128-1]\\] |\n| uint256 | 32 | \\[0, 2^256-1]\\] |\n| uint512 | 64 | \\[0, 2^512-1]\\] |\n| bigint | varying | \\[-2^8128 + 1, 2^8128 - 1\\] |\n \n\n如何定义布尔类型和正式类型，形式如下：\`变量类型 变量名\`;  例如：\n\n\`\`\`\n uint64 a;\n bool b;\n \`\`\`\n\n初始化变量：\n\n\`\`\`\n a = 5u64;\n b = true;\n \n \`\`\`\n\n 也可以变量声明和初始化一同进行：\n\n\`\`\`\n int32 c = 32i32;\n bigint balance = 3000000ib; \n\`\`\`\n\n  默认情况下，整型数被视为int32类型。如果定义是uint64类型，初始化时必须是uint64数，否则编辑器会报错。\n\n要强制使用特定类型，请附加后缀"u" (无符号类型)或 "i" (有符号类型), 再加上一个位宽，例如100u8, 1000i64。\n\n十六进制数也支持这些后缀。\n\nBigint类型以\`ib\`结尾，不需要位宽。\n\n### 实战演习\n\n请在右侧代码区域定义我们的Puppy属性：\n\n 1. 定义Puppy的序号，类型是\`uint64\`，变量名是\`id\`；\n\n 2. 定义Puppy的DNA，类型是\`uint64\`，变量名是\`dna\`；\n\n 3. 定义Puppy的年龄，类型是\`uint32\`，变量名是\`age\`；`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: `contract CryptoPuppy {\n   //在这里输入代码\n   \n}`,
          answer:
            "contract CryptoPuppy {\n    uint64 id;\n    uint64 dna;\n    uint32 age;\n}",
        },
      ],
    },
    {
      title: "第四章 合约中的状态变量",
      instruction: `## 第四章 合约中的状态变量\n\n前面章节中我们学会了如何定义合约和变量类型，本章节我们围绕合约继续介绍状态变量。\n\n 状态变量，即在合约内定义的变量，它必须定义在合约内，且拥有"状态"(作用域)，定义一个状态变量只需要在类型之前添加一个可选的作用域修饰符： \`@global\`，\`@shard\`，\`@address\`等。\n\n >没有任何作用域修饰的变量为全局作用域的状态变量, 等同使用@global修饰。\n\n状态变量的具体定义语法为：\n\n\`\`\`\n[@scope] TypeName variableName; \n\`\`\`\n\n 示例：\n\n\`\`\`\n//全局状态变量, @global可以省略 \n@global int32 pid = 3i32;\n\n//分片状态变量\n@shard int32 count = 10i32;\n\n//地址状态变量\n@address bigint balance = 300000000ib;\n\n//正整型值状态变量\n@uint64 int64 total = 200i64; \n\n\`\`\`\n\n PREDA内置了四种状态变量作用域修饰符： \n\n global全局作用域（\`@global\`）、shard分片作用域（\`@shard\`）、address地址作用域（\`@address\`）、uint 作用域(\`@uint16\`、\`@uint32\`、\`@uint64\`、\`@uint256\`、\`@uint512\`), 每一种状态变量，在所在作用域都有各自独立的实例。\n\n 1. global 作用域相当于传统智能合约，作用域中定义的所有内容在全局范围内只有一个实例。\n\n2. shard 作用域定义的变量，对于链上的每个分片，都有单独的一份。\n\n3. address 作用域定义的变量对于链上的每个有效地址都会各自有单独的一份。\n\n4. uint 作用域与 address作用域类似，不同之处在于所定义的状态针对相应的 uint 类型的每个有效值都有一个实例。 \n\n\n 在传统的非分片区块链上，每个智能合约的状态可以被视为单个全局实例，可在整个链上访问。在分片区块链上，智能合约的状态可以根据其分片方案分布在多个分片上，以实现并行处理。在PREDA模型中，合约开发人员可以通过使用作用域来灵活地定义合约在分片区块链上的状态结构。\n\n 一般来说，状态变量的作用域定义了链上有多少个该变量的副本以及它们如何索引；函数的作用域则定义了它可以访问哪些状态变量。\n\n ### 访问不同作用域中的状态变量和函数 \n\n 在除了 global 作用域之外的任何作用域中定义的状态变量可以在区块链上存储多个实例。当一个函数被执行时，它可以访问与其具有相同作用域的状态变量，但限于一个实例。这个实例由所谓的作用域目标进行索引。对于同一作用域的另一个目标中的变量，只能通过异步中继(relay)才能访问。\n\n 一般情况下，一个函数不能直接访问在另一个作用域中定义的状态变量，而只能通过中继(relay)到该作用域的函数来访问。 global 和 shard 作用域是两种特殊情况。由于 global 作用域只有一个实例，它可以在任何作用域中读取，但只能在 global 作用域内修改。它的常量函数也可以在任何作用域中直接调用。另外，在 shard 作用域中的状态变量在区块链的每个分片中各有一个实例。除了 global 作用域外的任何其他作用域都可以对当前分片中的实例进行读写访问。 \n\n ### 实战演习\n\n 本章我们要实现一个功能，让Puppy交易需要有唯一的标识（\`pid\`）。\n\n在已经建立好的\`CryptoPuppy\`合约基础上，使用\`global\`关键字，定义一个\`uint64\`的变量，变量名为\`pid\`。\n\n`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: `contract CryptoPuppy {
    //在这里输入代码
    uint64 id;
    uint64 dna;
    uint32 age;
}`,
          answer: `contract CryptoPuppy {
    @global uint64 pid;
    uint64 id;
    uint64 dna;
    uint32 age;
}`,
        },
      ],
    },
    {
      title: "第五章 字符串类型",
      instruction: `## 第五章 字符串类型\n\nstring包含UTF-8格式的字符数组。除了赋值（"\`=\`"），它还支持相等比较（"\`==\`"，"\`!=\`"）和通用比较（"\`<\`", "\`>\`", "\`<=\`", "\`>=\`"）运算符。字符串有以下内置成员函数，可以通过点运算符"\`.\`"\`访问:\n\n|  函数   |  返回类型  |  参数列表  |  常值函数  |  描述  |\n| :--: | :--: | :--: | :--: | :--: |\n| set | None | string str | 否 | 设置字符串内容 |\n|  append | None | string str | 否 | 在字符串最后添加内容 |\n|  length | uint32 | None | 是 | 字符串长度 |\n\n字符串：\`变量类型 变量名\`;  例如：\n\n\`\`\`\n string s;\n\`\`\`\n\n 使用\`=\`来初始化并且用用双引号\'\`"\`\'引起来，例如：\n\n\`\`\`\n s = "小A";\n\`\`\`\n\n### 实战演习\n\n细心的同学会发现，上一章我们定义Puppy的属性是数字值类。为了方便记忆和区分，我们给Puppy设置个名字（\`name\`表示）。\n\n 1. 定义Puppy的名字，类型是\`string\`，变量名是\`name\`；\n\n`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: "contract CryptoPuppy {\n    @global uint64 pid;\n    uint64 id;\n    uint64 dna;\n    uint32 age;\n    //在这里输入代码\n    \n}",
          answer:
            "contract CryptoPuppy {\n    @global uint64 pid;\n    uint64 id;\n    uint64 dna;\n    uint32 age;\n    string name;\n}",
        },
      ],
    },
    {
      title: "第六章 结构体",
      instruction: `## 第六章 结构体\n\n用户可以定义自己的结构体类型。\n\n \`struct\`是一个名称下组合在一起的数据的集合。结构的成员可以是任何内置类型和其他用户定义的结构。结构体不能具有成员函数。结构体的成员不能超过255个。\n\n结构体定义：\n\n \`\`\`\n struct MyStruct{\n    TypeA memberA;\n    TypeB memberB;\n    TypeC memberC;\n    ...\n}\n\`\`\`\n\n结构体成员通过"\`.\`"运算符访问，例如：\n\n\`\`\`\n // 参照前文定义的结构体\n MyStruct myStruct;\n myStruct.memberA = ...\n\`\`\`\n\n### 实战演习\n\n前面几章中我们定义了Puppy的一些基本属性，如何把这些属性用结构定义？请在右侧代码区域尝试写一写。\n\n 1. 将Puppy的\`id\`,\`age\`,\`dna\`, \`name\`属性使用\`struct\`定义，变量名是\`Puppy\`；\n\n`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: "contract CryptoPuppy {\n    @global uint64 pid;\n    uint64 id;\n    uint64 dna;\n    uint32 age;\n    string name;\n    //在这里输入代码\n    \n}",
          answer:
            "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        string name;\n    }\n}",
        },
      ],
    },
    {
      title: "第七章 数组",
      instruction: `## 第七章 数组\n\n一个\`array\`是包含相同类型的元件的动态大小的阵列。它支持运算符"**[]**"，索引类型必须为\`uint32\`。对应的值类型是定义时给定的第一个模数，例如array<int64>。数组具有以下内置的成员函数，可以通过点运算符"\`.\`"进行访问。\n\n |  函数   |  返回类型  |  参数列表  |  常值函数  |  描述  |\n| :--: | :--: | :--: | :--: | :--: |\n| length | uint32 |None | Yes | 返回数组中元素的个数 |\n|  push | None | valueType newElement | No | 在数组最后添加一个元素 |\n|  pop | None | None | No | 从数组中删除最后一个元素 |\n\n 数据定义，array<值类型> 变量名：\n\n\`\`\`\n array<uint64> aa;\n\`\`\` \n\n在数组最后添加一个元素：\n\n\`\`\`\n // 参照前文定义的数组\n aa.push(123u64);\n\`\`\`\n\n### 实战演习\n\n上一章我们把Puppy的属性定义到结构体中，想一想如果用户有多个Puppy如何定义？\n\n 1. 定义一个数组表示用户拥有的宠物，值类型是上一章结构体\`Puppy\`；\n\n 2. 数组的变量名是\`userPuppys\`；\n\n`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        string name;\n    }\n    //在这里输入代码\n}",
          answer:
            "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        string name;\n    }\n    array<Puppy> userPuppys;\n}",
        },
      ],
    },
  ],
};

const lesson2 = {
  lessonserial: "第2课",
  title: "",
  intro: [
    "在课程1中，我们学习了变量相关的操作，并成功定义Puppy的属性，为Puppy游戏的建立奠定第一块基石。在课程2中，我们将引导你搭建Puppy的框架，亲手打造自己的Puppy游戏。",
    "函数定义;键值图;环境变量: __block;if、do、while、for语句;内置随机数;地址状态",
  ],
  key: 2,
  total: 6,
  chapters: [
    {
      title: "第一章 函数定义",
      instruction: `## 第一章 函数定义\n\n### 格式：\n\n\`\`\`\n[scope] 'function' [returnValueType] FunctionName(['const'] parameterType parameterName, ...) [accessSpecifier] ['const'] {\n    //function body\n}\n\`\`\`\n\n如果未提供returnValueType，则该函数不返回任何值。\n\n### Scope 函数作用域修饰符 \n\n 用来表示它所修饰的变量的作用域。默认为global(全局)。\n\n 函数可以用\`@global\`,\`@address\`,\`@shard\`, \`@uint8\`, \`@uint16\`, \`@uint32\`, \`@uint64\`， \`@uint128\`， \`@uint256\`，\`@uint512\`定义作用域，每个修饰符的具体含义，我们已经在第一课第四章节的"状态变量"中已经介绍， 此刻我们不做重复叙述。 \n\n### 常量限定符\n\n常量限定符\`const\`可以出现在函数定义的两个位置：\n\n - 在参数的类型名称之前。在PREDA中，所有函数都通过引用传递参数，这意味着在函数内部对参数的任何修改都会反映到传入的参数上。使用const限定符，函数将不能再修改相应的参数。\n\n\ - 在参数列表后指定时。\`const\`使函数不能修改任何状态变量，也不能调用其他非const函数（无论是在同一合约中还是在另一个合约中），并且const 函数不能发起中继调用。\n\n### 访问说明符 \n\n 默认情况下，合约的所有函数只能从合约本身内部访问。为了使函数可以从其他位置访问，需要在函数定义中添加访问说明符。如\`export\`, 表示当前函数可以被交易调用。此处我们只简单介绍，后面会有章节详细说明访问说明符。\n\n ### 访问不同作用域中的状态变量和函数 \n\n 在除了 global 作用域之外的任何作用域中定义的状态变量可以在区块链上存储多个实例。当一个函数被执行时，它可以访问与其具有相同作用域的状态变量，但限于一个实例。这个实例由所谓的作用域目标进行索引。对于同一作用域的另一个目标中的变量，只能通过异步中继(relay)才能访问。\n\n 一般情况下，一个函数不能直接访问在另一个作用域中定义的状态变量，而只能通过中继(relay)到该作用域的函数来访问。 global 和 shard 作用域是两种特殊情况。由于 global 作用域只有一个实例，它可以在任何作用域中读取，但只能在 global 作用域内修改。它的常量函数也可以在任何作用域中直接调用。另外，在 shard 作用域中的状态变量在区块链的每个分片中各有一个实例。\n\n ### 实战演习 \n\n 上一节课我们定义Puppy的属性，那么下面我们定义一个创建Puppy的函数，Puppy的dna，age，id可以暂时设置为0，后续章节会讲如何完善这些属性。\n\n 1. 定义一个函数，函数名是\`createRandomPuppy\`；\n\n 2. 函数参数，参数名是\`puppyName\`，类型是\`string\`；\n\n 3. 追加到\`userPuppys\`数组中；\n\n 4. 函数\`createRandomPuppy\`可以被交易调用(使用\`export\`修饰)；\n\n `,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        string name;\n    }\n    array<Puppy> userPuppys;\n\n    //在这里输入代码\n}",
          answer:
            "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        string name;\n    }\n    array<Puppy> userPuppys;\n\n    function createRandomPuppy(string puppyName) export {\n        userPuppys.push(Puppy(0u64, 0u64, 0u32, puppyName));\n    }\n\n}",
        },
      ],
    },
    {
      title: "第二章 键值图",
      instruction: `## 第二章 键值图\n\n与其他语言类似，在PREDA语言中也有\`map\`类型，map是从键到值的映射。\n\n键类型和值类型是定义时给出的第一个和第二个参数，例如：\`map<address, string>\`， map以下内置的成员函数，可以通过点运算符"\`.\`"访问：\n\n|  函数   |  返回类型  |  参数列表  |  常值函数  |  描述  |\n| :--: | :--: | :--: | :--: | :--: |\n| has | bool | keyType key | Yes | 查询某个键是否在map中 |\n|  erase | None | keyType key | No | 将某个键从map中删除 |\n\n\n它还支持运算符"**[]**",比如： \n\n\n\`\`\`\n\nmap<uint32,uint32> myPuppyPostion; \nmyPuppyPostion[0u32] = 10u32; \n__debug.print(myPuppyPostion[0u32]); // output 10 \n\n \`\`\` \n\n\n ### 实战演习\n\n 我们将定义一个map，用于记录\`userPuppys\`中每个puppy位置。\n\n 1. 定义一个map，map名称是\`myPuppyPosition\`，状态作用域暂定为全局；\n\n 2. \`myPuppyPosition\` 键类型是\`uint64\`，值类型是\`uint32\`；\n\n 3. \`myPuppyPosition\`的键是puppy的\`id\`，值是\`userPuppys\`的位置索引；\n\n`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        string name;\n    }\n    array<Puppy> userPuppys;\n    //在这里输入代码\n\n    function createRandomPuppy(string puppyName) export {\n        userPuppys.push(Puppy(0u64, 0u64, 0u32, puppyName));\n        //在这里输入代码\n    }\n\n}",
          answer:
            "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        string name;\n    }\n    array<Puppy> userPuppys;\n    map<uint64,uint32> myPuppyPosition;\n\n    function createRandomPuppy(string puppyName) export {\n        userPuppys.push(Puppy(0u64, 0u64, 0u32, puppyName));\n        myPuppyPosition[0u64] = userPuppys.length() - 1u32;\n    }\n\n}",
        },
      ],
    },
    {
      title: "第三章 环境变量（__block）",
      instruction: `## 第三章 环境变量（__block）\n\n\`__block\`是块上下文环境变量，它有以下内置函数：\n\n|  名称   |  函数签名  |  描述  | \n| :--: | :--: | :--: | :--: |\n| get_height() | () -> uint64 | 返回块的高度 |\n|  get_shard_index() | () -> uint32 | 返回分片的索引 |\n|  get_shard_order() | () -> uint32 | 返回分片的秩 |\n|  get_random_number() | () -> uint64 | 基于块的元数据返回随机数 |\n|  get_timestamp() | () -> uint64 | 返回块的时间戳 |\n|  get_miner_address() | () -> address | 返回块的矿工地址 |\n\n所有变量和函数均为常量类型。\n\n### 实战演习\n\n在前面的章节我们有定义函数\`createRandomPuppy\`创建Puppy，接下来我们对\`createRandomPuppy\`不断完善。假设每个用户在同一个块高只能创建一只Puppy，那么我们要记录Puppy创建时的块高，该怎么修改呢？\n\n 1. 在结构体\`Puppy\`增加变量，变量名是\`birthHeight\`，类型：uint64；\n\n 2. 创建时使用\`get_height()\`；`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        //在这里输入代码\n        string name;\n    }\n    array<Puppy> userPuppys;\n    map<uint64,uint32> myPuppyPosition;\n\n    function createRandomPuppy(string puppyName) export {\n        //修改下面这行代码\n        userPuppys.push(Puppy(0u64, 0u64, 0u32, puppyName));\n        myPuppyPosition[0u64] = userPuppys.length() - 1u32;\n    }\n\n}",
          answer:
            "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        uint64 birthHeight;\n        string name;\n    }\n    array<Puppy> userPuppys;\n    map<uint64,uint32> myPuppyPosition;\n\n    function createRandomPuppy(string puppyName) export {\n        userPuppys.push(Puppy(0u64, 0u64, 0u32, __block.get_height(), puppyName));\n        myPuppyPosition[0u64] = userPuppys.length() - 1u32;\n    }\n\n}",
        },
      ],
    },
    {
      title: "第四章 if、do、while、for语句",
      instruction: `## 第四章 if、do、while、for语句\n\nPREDA语言中的这些语句与C语言中的语句类似。For之后必须是一个代码块，即便这个代码块中只有一条语句。例如：\n\n\`\`\`\nfor (int32 i = 0; i < 1000; i++){\n    //for body;\n}\n\`\`\`\n\nif, else, do, while 之后必须是一个代码块，即便这个代码块中只有一条语句。唯一的例外是else后紧接if, 此时它们可以连在一起：\n\n\`\`\`\nif (condition){\n    //statments\n}else {\n    //statments\n}\n\nif (condition){\n    //statments\n} else if (condition){\n    //statments\n}\nelse if (condition){\n    //statments\n}\nelse {\n    //statments\n}\n\ndo{\n    //statements\n} while(condition);\n\nwhile (condition){\n    //statements\n}\n\`\`\`\n\ncontinue、break、return 语句也和与C语言类似。\n\n ### 实战演习\n\n在上一章节我们知道每个用户在同一个块高只能创建一只Puppy，我们如何实现当且仅在没有创建Puppy的块高里创建Puppy?\n\n 首先我们要理解，区块链块高是自动递增的，位于\`userPuppys\`数组的最后一个数组项结构体里，存储的块高属性(\`birthHeight\`)即为已使用过的最大块高。\n\n在函数\`createRandomPuppy\`里做如下修改：\n\n 1. 取\`userPuppys\`最后一个数组项的\`birthHeight\` \n\n 2. 只有它小于当前block块高方可创建puppy；\n\n`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: "contract CryptoPuppy {\n    @global uint64 pid;\n    struct Puppy{\n        uint64 id;\n        uint64 dna;\n        uint32 age;\n        uint64 birthHeight;\n        string name;\n    }\n    array<Puppy> userPuppys;\n    map<uint64,uint32> myPuppyPosition;\n\n    function createRandomPuppy(string puppyName) export {\n        //在这里输入代码\n        userPuppys.push(Puppy(0u64, 0u64, 0u32, __block.get_height(), puppyName));\n        myPuppyPosition[0u64] = userPuppys.length() - 1u32;\n     }\n\n}",
          answer:
            "contract CryptoPuppy { \n    @global uint64 pid; \n    struct Puppy{ \n        uint64 id; \n        uint64 dna; \n        uint32 age; \n        uint64 birthHeight; \n        string name; \n    } \n    array<Puppy> userPuppys; \n    map<uint64,uint32> myPuppyPosition; \n \n    function createRandomPuppy(string puppyName) export { \n        uint64 currentHei = __block.get_height(); \n        uint32 len = userPuppys.length(); \n        if (userPuppys[len - 1u32].birthHeight < currentHei) { \n            userPuppys.push(Puppy(0u64, 0u64, 0u32, currentHei, puppyName)); \n            myPuppyPosition[0u64] = userPuppys.length() - 1u32; \n        } \n    } \n  }",
        },
      ],
    },
    {
      title: "第五章 内置随机数",
      instruction: `## 第五章 内置随机数\n\n在前面章节中，我们学习过环境变量（\`__block\`），__block有两个随机数方法：\n\n|  名称   |  函数签名  |  描述  |  依赖性  |\n| :--: | :--: | :--: | :--: |\n|  get_random_number() | () -> uint64 | 基于块的元数据生成一个随机数 | payload |\n|\n\n### 实战演习\n\n我们希望根据当前区块的深度来生成随机数。\n\n这个随机数作为Puppy的dna，这样每只Pupyy都是独一无二的。\n\n 1. 定义一个变量，名称：\`_dna\`，类型：\`uint64\`，初始化值：\`__block.get_random_number()\`；\n\n 2. 用\`_dna\`替换userPuppys.push(Puppy(0u64, \`0u64\`, 0u32, _height, puppyName))中的dna的初始化值；\n\n`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: "contract CryptoPuppy { \n    @global uint64 pid; \n    struct Puppy{ \n        uint64 id; \n        uint64 dna; \n        uint32 age; \n        uint64 birthHeight; \n        string name; \n    } \n    array<Puppy> userPuppys; \n    map<uint64,uint32> myPuppyPosition; \n \n    function createRandomPuppy(string puppyName) export { \n        uint64 currentHei = __block.get_height(); \n        uint32 len = userPuppys.length(); \n        if (userPuppys[len - 1u32].birthHeight < currentHei) { \n            userPuppys.push(Puppy(0u64, 0u64, 0u32, currentHei, puppyName)); \n            myPuppyPosition[0u64] = userPuppys.length() - 1u32; \n        } \n    }\n}",
          answer:
            "contract CryptoPuppy { \n    @global uint64 pid; \n    struct Puppy{ \n        uint64 id; \n        uint64 dna; \n        uint32 age; \n        uint64 birthHeight; \n        string name; \n    } \n    array<Puppy> userPuppys; \n    map<uint64,uint32> myPuppyPosition; \n\n    function createRandomPuppy(string puppyName) export { \n        uint64 currentHei = __block.get_height(); \n        uint32 len = userPuppys.length(); \n        uint64 _dna = __block.get_random_number(); \n        if (userPuppys[len - 1u32].birthHeight < currentHei) { \n            userPuppys.push(Puppy(0u64, _dna, 0u32, currentHei, puppyName)); \n            myPuppyPosition[0u64] = userPuppys.length() - 1u32; \n        } \n    } \n}",
        },
      ],
    },
    {
      title: "第六章 地址状态",
      instruction: `## 第六章 地址状态（@address）\n\n在前面章节，我们已经接触过状态变量的定义方式和含义，我们此处重点介绍下 @address 地址状态。\n\n 地址状态是通过\`@address\`作用域修饰符修饰的变量状态，可以被每一个链上有效地址单独持有。\n\n语法：\n\n\`\`\`\n@address TypeName variableName; \n\`\`\`\n\n### 实战演习\n\n我们做一些调整： \n\n首先，我们希望\`myPuppyPosition\`只记录当前用户自己的Puppy; \n\n 其次，为了方便后能准确找到要交易的Puppy，我们需要保证Puppy的pid唯一且有序自增。\n\n那我们该怎么做呢？\n\n 1. myPuppyPosition改为使用\`@address\`修饰；\n\n 2. 新Puppy被创建时\`pid\`自动加\`1\`；\n\n\n >实际上，在我们完成修改后，该合约代码是无法运行成功的，问题出在该合约存在跨作用域修改状态变量的情况，这里暂且卖个关子，我们会在后续的章节中告诉你怎么解决此问题。`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy { 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    // 这里修改代码
    map<uint64,uint32> myPuppyPosition; 

    function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            // 这里递增pid
            userPuppys.push(Puppy(0u64, _dna, 0u32, currentHei, puppyName)); 
            myPuppyPosition[0u64] = userPuppys.length() - 1u32; 
        } 
    } 
}`,
          answer: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint64> myPuppyPosition; 

    function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName)); 
            pid++;
            myPuppyPosition[pid] = len - 1u32; 
        } 
    } 
}`,
        },
      ],
    },
  ],
};

const lesson3 = {
  lessonserial: "第3课",
  title: "",
  intro: [
    "在之前的课程中，我们已经学习了如何创建Puppy。在接下来的第三课中，我们将为Puppy添砖加瓦，让它可玩性更高一些。",
    "系统保留函数: on_deploy();Relay语句执行;私有/公共函数;环境变量: __transaction;环境变量: __debug",
  ],
  key: 2,
  total: 5,
  chapters: [
    {
      title: "第一章 系统保留函数 on_deploy()",
      instruction: `## 第一章 系统保留函数 on_deploy() \n\n系统保留函数是一组由PREDA保留名称的特殊函数，用于特殊目的，并在系统的某些时刻被调用。\n\n \`on_deploy\` 是一个全局函数，当一个合约被部署时会被调用。它可以用于对合约状态进行一些初始化。其签名为：\n\n\`\`\`\n function on_deploy()\n\`\`\`\n\n\n\n### 实战演习\n\n在上一章中，我们想让Puppy的pid唯一且有序自增。细心同学会发现，有个BUG：在每次创建Puppy初始化\`pid\`并不能保证pid唯一。下面我们将用\`on_deploy()\`初始\`pid\`。\n\n1. 使用\`on_deploy()\`初始化\`pid\`，值为\`1u64\`； \n\n\n > 此章节合约会不能正常运行，原因是当前合约中存在跨作用域修改状态变量的情况，我们会在接下来的章节中介绍relay并且告诉你如何解决该问题`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            pid++; 
            userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName)); 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 
}
          `,
          answer: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            pid++; 
            userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName)); 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 

    function on_deploy() {
        pid = 1u64; 
    }
}`,
        },
      ],
    },
    {
      title: "第二章 Relay语句",
      instruction: `## 第二章 Relay语句 \n\n relay语句类似于函数调用，不同之处在于该调用是异步的。调用数据打包在所谓的“relay交易”中，并中继到目标地址以执行。relay语句本身立即返回。\n\n\`\`\`\n relay@TargetExpression functionName(params);\n relay@shards functionName(params);\n relay@global functionName(params);\n \`\`\`\n\n 在上面的示例中，有三种类型的中继目标: \n\n1. \`relay@TargetExpression\`一般形式，其中 \`TargetExpression\` 是一个表达式，其求值结果与函数的作用域匹配，该语句可以在全局\`@global\`和分片\`@shards\`作用域的函数中执行。\n\n 2. \`relay@shards \` 广播中继，它会中继到所有非全局分片。该语句只能被全局作用域\`@global\`函数执行。\n\n 3. \`relay@global\` 全局中继，它会中继到全局分片，该语句可以在除\`@global\`外的其他作用域内执行。\n\n\n 在所有类型中，被调用的函数必须来自同一个合约。\n\n\n### 具有匿名（Lambda）函数的relay语句\n\n relay语句可以内联定义一个lambda函数并relay到这个函数中。\n\n\`\`\`\nrelay@scopeName|'shards'|'global' ([constQualifier] parameterType parameterName = argumentExpression, ...) [constQualifier]{\n    // function body\n}\n\`\`\`\n\n格式与定义函数非常相似，但有以下几点区别：\n\n 1. 不需要提供函数名。编译器会自动为其生成一个名称。\n\n 2. 匿名函数的作用域是 scopeName、shards 或 global，取决于中继类型。\n\n 3. 对于参数列表中的每个参数，还必须提供值。\n\n 4. 可以使用“ auto”关键字作为参数类型。在这种情况下，类型是从相应的参数表达式中获取的。\n\n请注意，中继函数体在 TargetAddress 的每个地址上下文、目标分片的每个分片上下文，或全局上下文中执行。它与调用中继语句的当前上下文不应混淆。\n\n为了简化代码，还有另一种方法可以在带lambda函数的relay语句中指定参数：\n\n\`\`\`\n relay@someAddress (..., ^identifier, ...){\n }\n\`\`\`\n\n这等价于：\n\n\`\`\`\n relay@someAddress (..., auto identifier = identifier, ...){\n }\n\`\`\`\n\n### 实战演习\n\n接下来，我们将 \`createRandomPuppy\` 变成 \`@adress\`作用域，通过\`relay@gloabl\`的方式，去实现整个例子： \n\n 1. 分别 给\`userPuppys\`,\`myPuppyPosition\`，\`createRandomPuppy\`函数追加 \`@address\`修饰，使每个地址都持有一份实例； \n\n 2. 通过relay lambda的方式，去修改\`pid\`的值`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    // 此处修改 函数作用域为@address
    function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            // 此处 使用relay的方式修改全局状态变量pid
            pid++; 
            userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName)); 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 

    function on_deploy() {
        pid = 1u64; 
    }
}`,
          answer: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    // 此处修改 函数作用域为@address
    @address function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            // 此处 使用relay的方式修改全局状态变量pid
            relay@global (^_dna, ^currentHei, ^puppyName) {
                userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName));
                pid++; 
            } 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 

    function on_deploy() {
        pid = 1u64; 
    }
}`,
        },
      ],
    },
    {
      title: "第三章 环境变量（__transaction）",
      instruction: `## 第三章 环境变量（___transaction）\n\n\`__transaction\`是交易上下文环境变量，它有以下内置函数：\n\n | 名称        | 类型               | 描述                              | N | R | S | S |\n |------------------------------|----------------------------|------------------------------------------|---|---|---|---|\n | get_type()                   | \`() -> transaction_type\`   | 获取交易类型            | X | X | X | X |\n | get_self_address()           | \`() -> address\`            | 返回当前地址上下文对应的地址 (不能在shard函数中调用)	 | X | X | X | X |\n | get_sender()                 | \`() -> address\`            | 返回交易的第一个签署者或调用当前合约的合约。 | X | X | X | X |\n | get_timestamp()              | \`() -> uint64\`             | 得到交易的时间戳	            | X | X | X | X |\n | get_signers()                | \`() -> array<address>\`     | 得到签名人数	                    | X |   |   |   |\n | verify_signer()              | \`(uint32) -> bool\`         | 验证某个签名	        | X |   |   |   |\n | verify_signer()              | \`(address) -> bool\`        | 验证某个签名	          | X |   |   |   |\n | get_originated_shard_index() | \`() -> uint32\`             | 返回relay交易的源交易所在分片的索引	             |   | X |   |   |\n | get_originated_shard_order() | \`() -> uint32\`             | 返回relay交易的源交易所在分片的秩	          |   | X |   |   |\n | get_initiator_address()      | \`() -> address\`            | 返回relay交易的源交易所在的地址	  |   | X |   |   |\n \n\n\n所有变量和函数均为常量类型。\n\n\`\`\`\n enum transaction_type{\n     normal_type, // 被普通交易调用\n     relay_type, // 被relay交易调用\n     system_type, // 被系统调用\n     issue_type // 被issue语句调用\n }\n\`\`\`\n\n### 实战演习\n\n在前面的章节我们学习了如何创建Puppy，在创建时给Puppy起名字。如果我们需要重新命名Puppy的名字，那该怎么做呢？\n\n 1. 定义函数，名称是：\`renamePuppy\`，使用\`export\`修饰让函数可以被交易调用；\n\n 2. \`renamePuppy\`函数的第1个参数名\`id\`，类型：\`uint64\`；\n\n 3. \`renamePuppy\`函数的第2个参数名\`newName\`，类型：\`string\`；\n\n 4. 使用\`___transaction\`内置函数校验签名；\n\n 5. 修改\`userPuppys\`变量里对应\`id\`的\`name\`；`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    @address function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            relay@global (^_dna, ^currentHei, ^puppyName) {
                userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName));
                pid++; 
            } 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 

    function on_deploy() {
        pid = 1u64; 
    }
    
    // 此处输入

}`,
          answer: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    @address function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            relay@global (^_dna, ^currentHei, ^puppyName) {
                userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName));
                pid++; 
            } 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 

    function on_deploy() {
        pid = 1u64; 
    }

    @address function renamePuppy( uint64 id, string newName) export {
        if(__transaction.verify_signer(__transaction.get_self_address())){
            if(myPuppyPosition.has(id)){
                  uint32 index = myPuppyPosition[id];
                  relay@global (^index,^newName){
                      userPuppys[index].name = newName;
                  }
                
            }
        }
    }
}`,
        },
      ],
    },
    {
      title: "第四章 环境变量（__debug）",
      instruction: `## 第四章 环境变量（__debug）\n\n\`__debug\`是调试上下文环境变量，它有以下内置函数：\n\n| 名称        | 类型               | 描述                               | \n |-------------|--------------------|-------------------------------------------|\n | assert()    | \`(bool) -> void\`   | 如果为假：引发断言失败异常并终止执行。 |\n | assert()    | \`(bool, string) -> void\` | 如果为假：引发断言失败异常并终止执行，将字符串显示在日志中。 |\n | print()     | \`(arbitrary) -> void\` | 打印信息              |\n \n\n### 实战演习\n\n在上一章里我们定义函数\`renamePuppy\`重命名Puppy的名字，我们在该函数里加一些调试逻辑:\n\n 1. 将\`renamePuppy\`函数里的两个\`if\`语句改为\`__debug.assert()\`语句；`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    @address function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            relay@global (^_dna, ^currentHei, ^puppyName) {
                userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName));
                pid++; 
            } 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 

    function on_deploy() {
        pid = 1u64; 
    }

    @address function renamePuppy( uint64 id, string newName) export{
        // 此处修改代码 
        if(__transaction.verify_signer(__transaction.get_self_address())){
            if(myPuppyPosition.has(id)){
                uint32 index = myPuppyPosition[id];
                relay@global (^index,^newName){
                    userPuppys[index].name = newName;
                }
            }
        }
    }
}`,
          answer: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    @address function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            relay@global (^_dna, ^currentHei, ^puppyName) {
                userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName));
                pid++; 
            } 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 

    function on_deploy() {
        pid = 1u64; 
    }

    @address function renamePuppy( uint64 id, string newName) export{
        __debug.assert(__transaction.verify_signer(__transaction.get_self_address()));
        __debug.assert(myPuppyPosition.has(id));
        uint32 index = myPuppyPosition[id];
        relay@global (^index,^newName){
            userPuppys[index].name = newName;
        }
        
    }
}`,
        },
      ],
    },
    {
      title: "第五章 函数修饰符",
      instruction: `## 第五章 函数修饰符\n\n在函数定义章节我们了解过函数的定义，作用域修饰符，本章节我们重点介绍访问说明符。\n\n默认情况下，合约的所有函数只能从合约本身内部访问，为了使函数可以从其他位置访问，需要在函数定义中添加访问说明符。有两种访问说明符：\n\n |  说明符   |  访问权限  |  对函数本身的限制  |\n| :--: | :--: | :--: |\n| export | 可以被交易调用 | 参数列表中不能有move-only参数 |\n|  public | 可以被其他合约调用 | 无限制 |\n\n### 实战演习\n\n 在前面的章节中，我们已经完成了Puppy的创建和修改过程，这章我们将增加Puppy繁殖功能。\n\n 具体需求：\n\n - 每只Puppy只有当\`birthHeight\` 与当前区块块高至少差16才能进入繁殖期。\n\n - 繁殖后，Puppy进入3个块高度的冷却时间，然后才能再次繁殖。\n\n\n 繁殖时需要调用Puppy创建函数，想想这里如何修改:\n\n 1. 在结构体\`Puppy\`定义\`breedHeight\`变量，类型：\`uint64\`；\n\n2. 定义繁殖函数，函数名：\`breed\`，修饰符：\`export\`； 繁殖函数\`breed\`第1，2参数是需要参与繁殖的两个Puppy的id，参数名分别是\`id0\`、\`id1\`，类型\`uint64\`,第3参数是繁殖后Puppy的名称，参数名\`babyName\`，类型：\`string\`；\n\n 3. \`bread\`函数内，用\`__block.get_height()\` 与 puppy \`birthHeight\` 比较差值是否大于16,即是否已经进入繁殖期；\n\n 4. \`breed\`内继续比较 \`__block.get_height()\`和 \`breedHeight\`, 看差值是否大于3，即是否已经经过了冷却；`,
      type: 0,
      codes: [
        {
          title: "CryptoPuppy.prd",
          code: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight; 
        // 此处新增字段
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    @address function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            relay@global (^_dna, ^currentHei, ^puppyName) {
                // 此处修改
                userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, puppyName));
                pid++; 
            } 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 

    function on_deploy() {
        pid = 1u64; 
    }

    @address function renamePuppy( uint64 id, string newName) export{
        __debug.assert(__transaction.verify_signer(__transaction.get_self_address()));
        __debug.assert(myPuppyPosition.has(id));
        uint32 index = myPuppyPosition[id];
        relay@global (^index,^newName){
            userPuppys[index].name = newName;
        }
    }

    // 此处输入
}`,
          answer: `contract CryptoPuppy { 
    @global uint64 pid; 
    struct Puppy{ 
        uint64 id; 
        uint64 dna; 
        uint32 age; 
        uint64 birthHeight;
        uint64 breedHeight;  
        string name; 
    } 
    array<Puppy> userPuppys; 
    @address map<uint64,uint32> myPuppyPosition; 

    @address function createRandomPuppy(string puppyName) export { 
        uint64 currentHei = __block.get_height(); 
        uint32 len = userPuppys.length(); 
        uint64 _dna = __block.get_random_number(); 
        if (userPuppys[len - 1u32].birthHeight < currentHei) { 
            relay@global (^_dna, ^currentHei, ^puppyName) {
                userPuppys.push(Puppy(pid, _dna, 0u32, currentHei, 0u64, puppyName));
                pid++; 
            } 
            myPuppyPosition[pid] = userPuppys.length() - 1u32; 
        } 
    } 

    function on_deploy() {
        pid = 1u64; 
    }

    @address function renamePuppy( uint64 id, string newName) export{
        __debug.assert(__transaction.verify_signer(__transaction.get_self_address()));
        __debug.assert(myPuppyPosition.has(id));
        uint32 index = myPuppyPosition[id];
        relay@global (^index,^newName){
            userPuppys[index].name = newName;
        }
    }
    
    @address function breed(uint64 id0, uint64 id1, string babyName) export {
        uint64 _height = __block.get_height();
        __debug.assert(__transaction.verify_signer(__transaction.get_self_address()));
        __debug.assert(myPuppyPosition.has(id0));
        __debug.assert(myPuppyPosition.has(id1));

        __debug.assert(_height - userPuppys[myPuppyPosition[id0]].birthHeight > 16u32);
        __debug.assert(_height - userPuppys[myPuppyPosition[id0]].breedHeight > 3u64);
        __debug.assert(_height - userPuppys[myPuppyPosition[id1]].birthHeight > 16u32);
        __debug.assert(_height - userPuppys[myPuppyPosition[id1]].breedHeight > 3u64);

        createRandomPuppy(babyName);
        uint32 index0 = myPuppyPosition[id0];
        uint32 index1 = myPuppyPosition[id1];

        relay@global (^index0, ^index1, ^_height) {
            userPuppys[index0].breedHeight = _height;
            userPuppys[index1].breedHeight = _height;
        }
    }
}`,
        },
      ],
    },
  ],
};

const lessons = [lesson1, lesson2, lesson3];

export default lessons;
